import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  scales,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { FuelData } from "../data/FuelData";

ChartJS.register(
  LineElement,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export default function TheDiagram({data}) {
    const labels = Object.keys(data);
    const volumes = Object.values(data).filter(entry => entry.netto > 0);
    let labelsSet = [];

    for(const i of labels) {
      const label = FuelData.find(item => item.code === Number(i));
      labelsSet.push(label.name)
    } 

    const dataset = {
      labels: labelsSet,
      datasets: [
        {
          label: "Wolumen sprzedaży",
          data: volumes && volumes.map(item => item.volume),
          borderColor: "rgba(118, 174, 125, 0.44)",
          backgroundColor: "rgba(118, 174, 125, 0.44)",
        },
      ],
    };

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: "top",
          labels: {
            font: {
              family: 'Montserrat'
            }
          }
        },
        title: {
          display: false,
        },
      },
      scales: {
        x: {
          ticks: {
            font: {
              family: 'Montserrat'
            }
          }
        },
        y: {
        ticks: {
            font: {
              family: 'Montserrat'
            }
          }
        }
      }
    };

  return <Bar data={dataset} options={options} />;
}